
    const data = {"name":"src/core/icons/fullscreen","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M5 5h5v2H7v3H5V5m9 0h5v5h-2V7h-3V5m3 9h2v5h-5v-2h3v-3m-7 3v2H5v-5h2v3h3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            